"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAnnouncementFilesRequest = exports.validateCreateAnnouncementRequest = exports.AnnouncementFilesSchema = exports.AnnouncementSchema = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
// Shared subject/body/files rules for both Company- and Fund-mode announcements. Fund mode has no
// holder-type checkboxes, so it validates against this schema directly instead of AnnouncementSchema
// (whose object-level "atLeastOne" test only makes sense for the holder-type fields below).
const AnnouncementFilesSchema = yup.object().shape({
    subject: yup.string().required("Please enter the subject"),
    body: yup.string().required("Please enter the announcement content body"),
    files: yup
        .mixed()
        .nullable()
        // Attachments are optional — no files (null/undefined/empty) is valid, so create and Edit & resubmit
        // can both be sent with no attachment. Only enforce the size/type limits when files are provided.
        // `value` is a FileList (or File[]); a raw FileList has no `.forEach`, so iterate via Array.from.
        .test("filesize", "Maximum limit for file upload is 20MB.", (value) => {
        if (!value)
            return true;
        let totalSize = 0;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Array.from(value).forEach((item) => {
            totalSize += item.size;
        });
        return totalSize <= 20000000;
    })
        .test("type", "We only support pdf files.", (value) => {
        if (!value)
            return true;
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Array.from(value).forEach((item) => {
            if (item.type) {
                if (success && item.type !== "application/pdf") {
                    success = false;
                }
            }
            else if (success && item.mimeType && item.mimeType !== "application/pdf") {
                success = false;
            }
        });
        return success;
    }),
});
exports.AnnouncementFilesSchema = AnnouncementFilesSchema;
const AnnouncementSchema = AnnouncementFilesSchema.shape({
    includeShareholders: yup.boolean().required(),
    includeNoteholders: yup.boolean().required(),
    includeOptionholders: yup.boolean().required(),
}).test("atLeastOne", "At least one type must be selected", (value) => value.includeShareholders || value.includeNoteholders || value.includeOptionholders);
exports.AnnouncementSchema = AnnouncementSchema;
/**
 * Validates create announcement method request schema
 * @param data: create announcement method request data {@link IAnnouncement} to validate
 */
const validateCreateAnnouncementRequest = async (data) => {
    try {
        await AnnouncementSchema.validate(data, {
            abortEarly: false,
        });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateCreateAnnouncementRequest = validateCreateAnnouncementRequest;
/**
 * Validates the subject/body/files portion of a Fund-mode announcement (no holder-type fields).
 */
const validateAnnouncementFilesRequest = async (data) => {
    try {
        await AnnouncementFilesSchema.validate(data, {
            abortEarly: false,
        });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateAnnouncementFilesRequest = validateAnnouncementFilesRequest;
//# sourceMappingURL=Announcement.js.map